module.exports = __webpack_public_path__ + "images/0cd6aea075069b1e80be8aa28c6ba5ee.png";